import axios from "utils/axios";
import { GET_RFQ_PROJECTS } from "config/services";

const endpoint = (projectId, subProjectId = "") =>
  `${GET_RFQ_PROJECTS}/${encodeURIComponent(projectId)}/sub-projects${subProjectId ? `/${encodeURIComponent(subProjectId)}` : ""}`;

const payload = (response) => {
  if (response.data?.error !== false || response.data.payload === undefined) {
    throw new Error(response.data?.message || "Unable to load or save sub-projects.");
  }
  return response.data.payload;
};

export const listSubProjects = async (entityId, projectId, { signal, includeArchived = false } = {}) => {
  const rows = payload(await axios.get(endpoint(projectId), { params: { entityId, includeArchived }, signal }));
  if (!Array.isArray(rows)) throw new Error("Unable to load sub-projects. Please try again.");
  return rows;
};

export const saveSubProject = async (entityId, projectId, values, subProjectId) => {
  const saved = payload(await axios[subProjectId ? "put" : "post"](endpoint(projectId, subProjectId), { ...values, entityId }));
  if (!saved?._id || (subProjectId && saved._id !== subProjectId)) throw new Error("The sub-project save was not confirmed. Please try again.");
  return saved;
};

export const archiveSubProject = async (entityId, projectId, subProjectId) =>
  payload(await axios.delete(endpoint(projectId, subProjectId), { params: { entityId } }));
